import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, combineLatest, from, map, tap } from 'rxjs';
import { IEmployee } from 'src/app/employee/employee';
import { IUpdateWorkTimeRequest, IWorkTime } from 'src/app/employee/models/work-time';
import { WorkTimeService } from 'src/app/employee/services/work-time.service';
import { ITenantSettings } from 'src/app/setting/tenant-settings/models/tenant-setting';
import { isEmptyTimeSpanMask } from 'src/app/shared/helpers/isEmptyTimeSpanMask';
import { TimeSpan } from 'src/app/shared/helpers/time-span';
import { EmployeeStore } from 'src/app/stores/component/employee.store';
import { WorkTimesStore } from 'src/app/stores/component/work-times.store';

@UntilDestroy()
@Component({
    selector: 'app-work-time-form',
    templateUrl: './work-time-form.component.html',
    styleUrls: ['./work-time-form.component.css'],
    standalone: false
})
export class WorkTimeFormComponent implements OnInit {

  constructor(
    private workTimesStore: WorkTimesStore,
    private employeeStore: EmployeeStore
  ) { }

  @Input() set workTime(value: IWorkTime){
    this.workTime$.next(value);
  };
  @Input() employee: IEmployee;
  @Input() tenantSettings: ITenantSettings;
  @Input() isFirstWorkTime: boolean = false;

  public formGroup!: UntypedFormGroup;

  showDeleteModal : boolean = false;
  showUpdateModal : boolean = false;
  confirmText = '';


  editMask = "AB:CD";
  maskRules: { [key: string]: RegExp } = {
    A: /[0-2]+/,
    B: /[0-9]+/,
    C: /[0-5]+/,
    D: /[0-9]+/,
  };

  workTime$ = new BehaviorSubject<IWorkTime>(null);

  vm$ = combineLatest([
    this.employeeStore.employee$,
    this.workTime$.pipe(
      tap(workTime => {
        if(workTime){
          this.updateFormGroup(workTime);
        }}
      )
    ),
    this.workTimesStore.workTimes$
  ]).pipe(
    map(([
      employee,
      workTime,
      workTimes
    ]) => ({
      employee,
      workTime,
      workTimes
    }))
  );

  ngOnInit(): void {
    this.createFormGroup(this.workTime);
  }

  onOpenUpdatePopUp(){

  }

  onSubmit(){
      const formValues = this.formGroup.value;
      const request : IUpdateWorkTimeRequest = {
        ...formValues,
        employeeId: formValues.employeeId ?? this.employee.id,
        validFrom: new Date (formValues.validFrom).toDateString(),
        validTo: formValues.validTo ? new Date (formValues.validTo).toDateString() : null,

        workHourAmountMonday: !isEmptyTimeSpanMask(formValues.workHourAmountMonday) ? TimeSpan.parse(formValues.workHourAmountMonday).toString() : null,
        preliminaryWorktimeMonday: !isEmptyTimeSpanMask(formValues.preliminaryWorktimeMonday) ? TimeSpan.parse(formValues.preliminaryWorktimeMonday).toString() : null,
        mondayMorningFrom: !isEmptyTimeSpanMask(formValues.mondayMorningFrom) ? TimeSpan.parse(formValues.mondayMorningFrom).toString() : null,
        mondayMorningTo: !isEmptyTimeSpanMask(formValues.mondayMorningTo) ? TimeSpan.parse(formValues.mondayMorningTo).toString() : null,
        mondayAfternoonFrom: !isEmptyTimeSpanMask(formValues.mondayAfternoonFrom) ? TimeSpan.parse(formValues.mondayAfternoonFrom).toString() : null,
        mondayAfternoonTo: !isEmptyTimeSpanMask(formValues.mondayAfternoonTo) ? TimeSpan.parse(formValues.mondayAfternoonTo).toString() : null,

        workHourAmountTuesday: !isEmptyTimeSpanMask(formValues.workHourAmountTuesday) ? TimeSpan.parse(formValues.workHourAmountTuesday).toString() : null,
        preliminaryWorktimeTuesday: !isEmptyTimeSpanMask(formValues.preliminaryWorktimeTuesday) ? TimeSpan.parse(formValues.preliminaryWorktimeTuesday).toString() : null,
        tuesdayMorningFrom: !isEmptyTimeSpanMask(formValues.tuesdayMorningFrom) ? TimeSpan.parse(formValues.tuesdayMorningFrom).toString() : null,
        tuesdayMorningTo: !isEmptyTimeSpanMask(formValues.tuesdayMorningTo) ? TimeSpan.parse(formValues.tuesdayMorningTo).toString() : null,
        tuesdayAfternoonFrom: !isEmptyTimeSpanMask(formValues.tuesdayAfternoonFrom) ? TimeSpan.parse(formValues.tuesdayAfternoonFrom).toString() : null,
        tuesdayAfternoonTo: !isEmptyTimeSpanMask(formValues.tuesdayAfternoonTo) ? TimeSpan.parse(formValues.tuesdayAfternoonTo).toString() : null,

        workHourAmountWednesday: !isEmptyTimeSpanMask(formValues.workHourAmountWednesday) ? TimeSpan.parse(formValues.workHourAmountWednesday).toString() : null,
        preliminaryWorktimeWednesday: !isEmptyTimeSpanMask(formValues.preliminaryWorktimeWednesday) ? TimeSpan.parse(formValues.preliminaryWorktimeWednesday).toString() : null,
        wednesdayMorningFrom: !isEmptyTimeSpanMask(formValues.wednesdayMorningFrom) ? TimeSpan.parse(formValues.wednesdayMorningFrom).toString() : null,
        wednesdayMorningTo: !isEmptyTimeSpanMask(formValues.wednesdayMorningTo) ? TimeSpan.parse(formValues.wednesdayMorningTo).toString() : null,
        wednesdayAfternoonFrom: !isEmptyTimeSpanMask(formValues.wednesdayAfternoonFrom) ? TimeSpan.parse(formValues.wednesdayAfternoonFrom).toString() : null,
        wednesdayAfternoonTo: !isEmptyTimeSpanMask(formValues.wednesdayAfternoonTo) ? TimeSpan.parse(formValues.wednesdayAfternoonTo).toString() : null,

        workHourAmountThursday: !isEmptyTimeSpanMask(formValues.workHourAmountThursday) ? TimeSpan.parse(formValues.workHourAmountThursday).toString() : null,
        preliminaryWorktimeThursday: !isEmptyTimeSpanMask(formValues.preliminaryWorktimeThursday) ? TimeSpan.parse(formValues.preliminaryWorktimeThursday).toString() : null,
        thursdayMorningFrom: !isEmptyTimeSpanMask(formValues.thursdayMorningFrom) ? TimeSpan.parse(formValues.thursdayMorningFrom).toString() : null,
        thursdayMorningTo: !isEmptyTimeSpanMask(formValues.thursdayMorningTo) ? TimeSpan.parse(formValues.thursdayMorningTo).toString() : null,
        thursdayAfternoonFrom: !isEmptyTimeSpanMask(formValues.thursdayAfternoonFrom) ? TimeSpan.parse(formValues.thursdayAfternoonFrom).toString() : null,
        thursdayAfternoonTo: !isEmptyTimeSpanMask(formValues.thursdayAfternoonTo) ? TimeSpan.parse(formValues.thursdayAfternoonTo).toString() : null,

        workHourAmountFriday: !isEmptyTimeSpanMask(formValues.workHourAmountFriday) ? TimeSpan.parse(formValues.workHourAmountFriday).toString() : null,
        preliminaryWorktimeFriday: !isEmptyTimeSpanMask(formValues.preliminaryWorktimeFriday) ? TimeSpan.parse(formValues.preliminaryWorktimeFriday).toString() : null,
        fridayMorningFrom: !isEmptyTimeSpanMask(formValues.fridayMorningFrom) ? TimeSpan.parse(formValues.fridayMorningFrom).toString() : null,
        fridayMorningTo: !isEmptyTimeSpanMask(formValues.fridayMorningTo) ? TimeSpan.parse(formValues.fridayMorningTo).toString() : null,
        fridayAfternoonFrom: !isEmptyTimeSpanMask(formValues.fridayAfternoonFrom) ? TimeSpan.parse(formValues.fridayAfternoonFrom).toString() : null,
        fridayAfternoonTo: !isEmptyTimeSpanMask(formValues.fridayAfternoonTo) ? TimeSpan.parse(formValues.fridayAfternoonTo).toString() : null,

        workHourAmountSaturday: !isEmptyTimeSpanMask(formValues.workHourAmountSaturday) ? TimeSpan.parse(formValues.workHourAmountSaturday).toString() : null,
        preliminaryWorktimeSaturday: !isEmptyTimeSpanMask(formValues.preliminaryWorktimeSaturday) ? TimeSpan.parse(formValues.preliminaryWorktimeSaturday).toString() : null,
        saturdayMorningFrom: !isEmptyTimeSpanMask(formValues.saturdayMorningFrom) ? TimeSpan.parse(formValues.saturdayMorningFrom).toString() : null,
        saturdayMorningTo: !isEmptyTimeSpanMask(formValues.saturdayMorningTo) ? TimeSpan.parse(formValues.saturdayMorningTo).toString() : null,
        saturdayAfternoonFrom: !isEmptyTimeSpanMask(formValues.saturdayAfternoonFrom) ? TimeSpan.parse(formValues.saturdayAfternoonFrom).toString() : null,
        saturdayAfternoonTo: !isEmptyTimeSpanMask(formValues.saturdayAfternoonTo) ? TimeSpan.parse(formValues.saturdayAfternoonTo).toString() : null,

        workHourAmountSunday: !isEmptyTimeSpanMask(formValues.workHourAmountSunday) ? TimeSpan.parse(formValues.workHourAmountSunday).toString() : null,
        preliminaryWorktimeSunday: !isEmptyTimeSpanMask(formValues.preliminaryWorktimeSunday) ? TimeSpan.parse(formValues.preliminaryWorktimeSunday).toString() : null,
        sundayMorningFrom: !isEmptyTimeSpanMask(formValues.sundayMorningFrom) ? TimeSpan.parse(formValues.sundayMorningFrom).toString() : null,
        sundayMorningTo: !isEmptyTimeSpanMask(formValues.sundayMorningTo) ? TimeSpan.parse(formValues.sundayMorningTo).toString() : null,
        sundayAfternoonFrom: !isEmptyTimeSpanMask(formValues.sundayAfternoonFrom) ? TimeSpan.parse(formValues.sundayAfternoonFrom).toString() : null,
        sundayAfternoonTo: !isEmptyTimeSpanMask(formValues.sundayAfternoonTo) ? TimeSpan.parse(formValues.sundayAfternoonTo).toString() : null,
      }
  
      if(request?.id){
        this.workTimesStore.updateWorkTime(request)
      } else {
        this.workTimesStore.createWorkTime(request);
      }
      this.showUpdateModal = null;
      this.confirmText = null;
  }

  updateFormGroup(data: IWorkTime){
    this.formGroup.patchValue({
      ...data,
      validFrom: data.validFrom ? new Date(data.validFrom) : null,
      validTo: data.validTo ? new Date(data.validTo) : null,
      workHoursAmountWeek: data?.workHourAmountWeek ?  TimeSpan.parse(data.workHourAmountWeek).getAsTimeObject() : null
    });
  }

  createFormGroup(data: IWorkTime = null){
    this.formGroup =  new UntypedFormGroup({
      id: new UntypedFormControl(data?.id ?? null),
      employeeId: new UntypedFormControl(data?.employeeId ?? null),
      validFrom: new UntypedFormControl(data?.validFrom ? new Date(data?.validFrom) : null, Validators.required),
      validTo: new UntypedFormControl(data?.validTo ? new Date(data?.validTo) : null),
      hasFlexTime: new UntypedFormControl(data?.hasFlexTime ?? false, Validators.required),
      vacationDays: new UntypedFormControl(data?.vacationDays ?? null, {validators: [Validators.required]}),
      initialVacationDays: new UntypedFormControl(data?.initialVacationDays ?? null),
      workload: new UntypedFormControl(data?.workload ?? 100, Validators.required),
      workHourAmountWeek: new UntypedFormControl(data?.workHourAmountWeek ?  TimeSpan.parse(data.workHourAmountWeek).getAsTimeObject() : null),
      hourlyRateInternal: new UntypedFormControl(data?.hourlyRateInternal ?? null),
      hourlyRateExternal: new UntypedFormControl(data?.hourlyRateExternal ?? null),

      workHourAmountMonday: new UntypedFormControl(data?.workHourAmountMonday ?? this.tenantSettings.defaultWorkTime),
      preliminaryWorktimeMonday: new UntypedFormControl(data?.preliminaryWorktimeMonday ?? this.tenantSettings.preliminaryWorktime),
      mondayMorningFrom: new UntypedFormControl(data?.mondayMorningFrom ?? this.tenantSettings.startMorningWorkTime),
      mondayMorningTo: new UntypedFormControl(data?.mondayMorningTo ?? this.tenantSettings.endMorningWorkTime),
      mondayAfternoonFrom: new UntypedFormControl(data?.mondayAfternoonFrom ?? this.tenantSettings.startAfternoonWorkTime),
      mondayAfternoonTo: new UntypedFormControl(data?.mondayAfternoonTo ?? this.tenantSettings.endAfternoonWorkTime),
      
      workHourAmountTuesday: new UntypedFormControl(data?.workHourAmountTuesday ?? this.tenantSettings.defaultWorkTime),
      preliminaryWorktimeTuesday: new UntypedFormControl(data?.preliminaryWorktimeTuesday ?? this.tenantSettings.preliminaryWorktime),
      tuesdayMorningFrom: new UntypedFormControl(data?.tuesdayMorningFrom ?? this.tenantSettings.startMorningWorkTime),
      tuesdayMorningTo: new UntypedFormControl(data?.tuesdayMorningTo ?? this.tenantSettings.endMorningWorkTime),
      tuesdayAfternoonFrom: new UntypedFormControl(data?.tuesdayAfternoonFrom ?? this.tenantSettings.startAfternoonWorkTime),
      tuesdayAfternoonTo: new UntypedFormControl(data?.tuesdayAfternoonTo ?? this.tenantSettings.endAfternoonWorkTime),

      workHourAmountWednesday: new UntypedFormControl(data?.workHourAmountWednesday ?? this.tenantSettings.defaultWorkTime),
      preliminaryWorktimeWednesday: new UntypedFormControl(data?.preliminaryWorktimeWednesday ?? this.tenantSettings.preliminaryWorktime),
      wednesdayMorningFrom: new UntypedFormControl(data?.wednesdayMorningFrom ?? this.tenantSettings.startMorningWorkTime),
      wednesdayMorningTo: new UntypedFormControl(data?.wednesdayMorningTo ?? this.tenantSettings.endMorningWorkTime),
      wednesdayAfternoonFrom: new UntypedFormControl(data?.wednesdayAfternoonFrom ?? this.tenantSettings.startAfternoonWorkTime),
      wednesdayAfternoonTo: new UntypedFormControl(data?.wednesdayAfternoonTo ?? this.tenantSettings.endAfternoonWorkTime),

      workHourAmountThursday: new UntypedFormControl(data?.workHourAmountThursday ?? this.tenantSettings.defaultWorkTime),
      preliminaryWorktimeThursday: new UntypedFormControl(data?.preliminaryWorktimeThursday ?? this.tenantSettings.preliminaryWorktime),
      thursdayMorningFrom: new UntypedFormControl(data?.thursdayMorningFrom ?? this.tenantSettings.startMorningWorkTime),
      thursdayMorningTo: new UntypedFormControl(data?.thursdayMorningTo ?? this.tenantSettings.endMorningWorkTime),
      thursdayAfternoonFrom: new UntypedFormControl(data?.thursdayAfternoonFrom ?? this.tenantSettings.startAfternoonWorkTime),
      thursdayAfternoonTo: new UntypedFormControl(data?.thursdayAfternoonTo ?? this.tenantSettings.endAfternoonWorkTime),

      workHourAmountFriday: new UntypedFormControl(data?.workHourAmountFriday ?? this.tenantSettings.defaultWorkTime),
      preliminaryWorktimeFriday: new UntypedFormControl(data?.preliminaryWorktimeFriday ?? this.tenantSettings.preliminaryWorktime),
      fridayMorningFrom: new UntypedFormControl(data?.fridayMorningFrom ?? this.tenantSettings.startMorningWorkTime),
      fridayMorningTo: new UntypedFormControl(data?.fridayMorningTo ?? this.tenantSettings.endMorningWorkTime),
      fridayAfternoonFrom: new UntypedFormControl(data?.fridayAfternoonFrom ?? this.tenantSettings.startAfternoonWorkTime),
      fridayAfternoonTo: new UntypedFormControl(data?.fridayAfternoonTo ?? this.tenantSettings.endAfternoonWorkTime),

      workHourAmountSaturday: new UntypedFormControl(data?.workHourAmountSaturday ?? null),
      preliminaryWorktimeSaturday: new UntypedFormControl(data?.preliminaryWorktimeSaturday ?? null),
      saturdayMorningFrom: new UntypedFormControl(data?.saturdayMorningFrom ?? null),
      saturdayMorningTo: new UntypedFormControl(data?.saturdayMorningTo ?? null),
      saturdayAfternoonFrom: new UntypedFormControl(data?.saturdayAfternoonFrom ?? null),
      saturdayAfternoonTo: new UntypedFormControl(data?.saturdayAfternoonTo ?? null),

      workHourAmountSunday: new UntypedFormControl(data?.workHourAmountSunday ?? null),
      preliminaryWorktimeSunday: new UntypedFormControl(data?.preliminaryWorktimeSunday ?? null),
      sundayMorningFrom: new UntypedFormControl(data?.sundayMorningFrom ?? null),
      sundayMorningTo: new UntypedFormControl(data?.sundayMorningTo ?? null),
      sundayAfternoonFrom: new UntypedFormControl(data?.sundayAfternoonFrom ?? null),
      sundayAfternoonTo: new UntypedFormControl(data?.sundayAfternoonTo ?? null)
    });
    this.checkHolidayValue();
  }

  checkHolidayValue(){
    this.formGroup.get('vacationDays').valueChanges.pipe(untilDestroyed(this)).subscribe(
      value => {
        const roundedValue = Math.round(value * 2) / 2;
        if (roundedValue !== value) {
          this.formGroup.get('vacationDays').patchValue(roundedValue)
        }
      }
    )
  }

  handleUpdatePopUp(){
    const formValues = this.formGroup.value;

    if(formValues.id == null){
      this.onSubmit();
    }
    else {
      this.showUpdateModal = true
    }


  }

  onDelete(){
    this.workTimesStore.deleteWorkTime(this.formGroup.get('id').value);
    this.showDeleteModal = null;
    this.confirmText = null;
  }
}
